var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeader", { attrs: { "no-padding": "", icon: "assignment" } }),
      _vm._v(" "),
      _c("Subheader", {
        attrs: { title: "Analytes", search: "analytes" },
        model: {
          value: _vm.search,
          callback: function ($$v) {
            _vm.search = $$v
          },
          expression: "search",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.MasterAnalyteList,
              pagination: _vm.pagination,
              search: _vm.search,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function (props) {
                  return [
                    _c("td", { staticClass: "text-xs-left keep_space" }, [
                      _vm._v(_vm._s(props.item.Name)),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(props.item.Description))]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "text-xs-right" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              small: "",
                              to: {
                                name: "AnalyteDetailManage",
                                params: { analyteId: props.item.Id.toString() },
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("Button.View")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }